// Dependencies
import React, { Component } from 'react';

// Styling
import './form-step-title.scss';

class RegistrationFormStepTitleComponent extends Component {

    render() {
        return (
            <>
                <div className="col-12">
                    <p style={{fontSize: "18px"}}>{this.props.title}</p>
                </div>
                <div className="col-12 t-align-left mgt-20">
                    {this.props.subtitles.map((subtitle) => {
                        return (
                            <p style={{fontSize: "14px"}}>{subtitle}</p>
                        );
                    })}
                </div>
            </>
        );
    }
}

export default RegistrationFormStepTitleComponent;